var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.02 8.94662L14.0534 7.97995L14.9867 7.04662C15.18 6.85329 15.18 6.53329 14.9867 6.33995C14.7934 6.14662 14.4734 6.14662 14.28 6.33995L13.3467 7.27329L12.38 6.30662C12.1867 6.11329 11.8667 6.11329 11.6734 6.30662C11.48 6.49995 11.48 6.81995 11.6734 7.01329L12.64 7.97995L11.6467 8.97329C11.4534 9.16662 11.4534 9.48662 11.6467 9.67996C11.7467 9.77995 11.8734 9.82662 12 9.82662C12.1267 9.82662 12.2534 9.77995 12.3534 9.67996L13.3467 8.68662L14.3134 9.65329C14.4134 9.75329 14.54 9.79995 14.6667 9.79995C14.7934 9.79995 14.92 9.75329 15.02 9.65329C15.2134 9.45995 15.2134 9.14662 15.02 8.94662Z",
    fill: "#F7F6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34671 2.52014C8.60004 2.10681 7.64671 2.21347 6.67337 2.82014L4.72671 4.04014C4.59337 4.12014 4.44004 4.16681 4.28671 4.16681H3.66671H3.33337C1.72004 4.16681 0.833374 5.05347 0.833374 6.66681V9.33347C0.833374 10.9468 1.72004 11.8335 3.33337 11.8335H3.66671H4.28671C4.44004 11.8335 4.59337 11.8801 4.72671 11.9601L6.67337 13.1801C7.26004 13.5468 7.83337 13.7268 8.36671 13.7268C8.71337 13.7268 9.04671 13.6468 9.34671 13.4801C10.0867 13.0668 10.5 12.2068 10.5 11.0601V4.94014C10.5 3.79347 10.0867 2.93347 9.34671 2.52014Z",
    fill: "#F7F6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundMute);
export default __webpack_public_path__ + "static/media/sound-mute.09d093e60e4a963357f6b026a9d64061.svg";
export { ForwardRef as ReactComponent };